import React from "react"
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"

import { useUserSettingsWebSupplierGroup } from "../@hooks"


export default function WebSupplierGroupTabButton() {
	const { handleSetFormData } = useUserSettingsWebSupplierGroup()

	return <ButtonLoadingSeeker
		startIcon={<IconSeeker icon="add" />}
		onClick={handleSetFormData}
	>
		Define Group
	</ButtonLoadingSeeker>
}